import { PartnerAttendance } from '@/shared/domain/models';
import { Channels } from '@/shared/domain/enums';

export const getAttendances = (attendances: PartnerAttendance[]): string => {
  const filterByPortal = attendances.filter((attendance) => attendance.channel === Channels.Portal);
  const mapByProduct = filterByPortal.map((attendance: PartnerAttendance) => attendance.product);

  return mapByProduct.join(' | ');
};
